import React, { Component } from 'react';
import { intlShape, FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import PopupLink from '../../../shared-components/PopupLink/PopupLink';

const USER_AGRMT_URL = 'https://www.paypal.com/webapps/mpp/ua/useragreement-full?country.x=US&locale.x=en_US';
const USER_POLICY_URL = 'https://www.paypal.com/webapps/mpp/ua/privacy-full?country.x=US&locale.x=en_US';
const ACCEPTABLE_USE_POLICY_URL = 'https://www.paypal.com/webapps/mpp/ua/acceptableuse-full?country.x=US&locale.x=en_US';
const COMM_DELIVERY_POLICY_URL = 'https://www.paypal.com/webapps/mpp/ua/esign-full?country.x=US&locale.x=en_US';
const LOCALE_PREFIX = 'components/PPTermsCheckBox/PPTermsCheckBox';

export class NewCustomerTermsLabel extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
    };

    render() {
        const { intl } = this.props;
        return (
            <div>
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.age-consent-text`}
                />&nbsp;
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.eSign-text-1`}
                />&nbsp;
                <PopupLink
                    url={COMM_DELIVERY_POLICY_URL}
                    className="popup accessible-link"
                    name="user-agreement"
                >
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.eSign-link-text`}
                    />
                </PopupLink>
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.eSign-text-2`}
                />&nbsp;
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.userAgrmt-text-1`}
                />&nbsp;
                <PopupLink
                    url={USER_AGRMT_URL}
                    className="popup accessible-link"
                    name="user-agreement"
                >
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.userAgrmt-link-text`}
                    />
                </PopupLink>
                <FormattedHTMLMessage
                    id={`${LOCALE_PREFIX}.userAgrmt-text-2`}
                />&nbsp;
                <PopupLink
                    url={USER_POLICY_URL}
                    className="popup accessible-link"
                    name="user-agreement"
                >
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.privacy-statement-link-text`}
                    />
                </PopupLink>
            </div>

        );
    }
}

export default injectIntl(NewCustomerTermsLabel);
